import React from 'react';

const Experience = () => {
    const experiences = [
        {
            title: "Software Engineer Intern",
            company: "Relational AI",
            date: "06/2025 - 09/2025",
            location: "Berkeley, CA",
            description: [
                "Designed and implemented automated IT analytics pipeline integrating Google Workspace, GitHub, Jira, and Confluence data sources using Python, improving KPI dashboard coverage and reliability across multiple platforms",
                "Debugged and resolved GitHub API failures in analytics infrastructure, restoring end-to-end data freshness for critical engineering metrics tracked by leadership",
                "Built Google Workspace integration from scratch to automatically track user provisioning, account activity, and license utilization across 160+ employee accounts",
                "Architected new GitHub repository and workflow automation for Quarterly Review process, enabling standardized reporting and template reuse across departments",
                "Enhanced IT operational visibility by adding dynamic Jira ticket views and emoji-based status indicators to Confluence scorecards, reducing status check time for stakeholders",
                "Established CMDB (Configuration Management Database) foundation by populating Jira Assets with 25+ SaaS subscriptions, including vendor details, renewal dates, and SOC 2 compliance status",
                "Updated security documentation on customer-facing Trust Center site, improving transparency of company security practices and policies",
                "Managed IT helpdesk ticket triage and resolution for repository access requests and tooling issues"
            ]
        },
        {
            title: "Internship Student",
            company: "Palo Alto Technologies",
            date: "08/2024 - 09/2024",
            location: "Palo Alto, CA",
            description: [
                "Developed front-end components using React.js including file upload interfaces, navigation systems, button components, and embedded PDF viewers",
                "Implemented RESTful API routes for file management operations, dynamic PDF generation, and database CRUD functionality",
                "Containerized front-end and back-end services using Docker, ensuring consistent deployment environments and service isolation across development and production",
                "Led version control management for 5-person development team, including repository architecture, branching strategy, PR reviews, and merge conflict resolution",
                "Participated in Agile development cycles with focus on production-ready code, scalability considerations, and system uptime"
            ]
        },
        {
            title: "Webmaster",
            company: "Theta Tau Professional Engineering Fraternity",
            date: "09/2024 - Present",
            location: "Santa Clara, CA",
            description: [
                "Built and deployed responsive React.js website for 60+ member engineering fraternity chapter",
                "Implemented Firebase Authentication for secure member login and role-based access control",
                "Designed Firestore database schema and integrated Firebase Storage for member data management and file hosting"
            ]
        }
    ];

    return (
        <main className="pt-32 pb-24 min-h-screen bg-background-dark">
            <div className="max-w-[1000px] mx-auto px-8">
                <div className="flex items-center gap-4 mb-16">
                    <span className="w-12 h-[2px] bg-primary"></span>
                    <h1 className="text-5xl md:text-7xl font-black sports-font text-white">
                        CAREER <span className="text-primary">HISTORY</span>
                    </h1>
                </div>

                <div className="space-y-12">
                    {experiences.map((exp, index) => (
                        <div key={index} className="group relative bg-surface-dark border border-white/5 p-8 md:p-12 transition-all hover:border-primary/30">
                            <div className="absolute top-0 right-0 p-4 opacity-10 font-black text-6xl sports-font text-white group-hover:text-primary transition-colors">
                                0{index + 1}
                            </div>

                            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 border-b border-white/5 pb-8 relative z-10">
                                <div>
                                    <h3 className="text-2xl md:text-3xl font-black text-white mb-2">{exp.title}</h3>
                                    <div className="flex items-center gap-2 text-primary font-bold uppercase tracking-widest text-sm">
                                        <span>{exp.company}</span>
                                        <span className="text-white/20">•</span>
                                        <span>{exp.location}</span>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <span className="inline-block px-4 py-2 bg-white/5 text-white font-mono text-sm border border-white/10">
                                        {exp.date}
                                    </span>
                                </div>
                            </div>

                            <ul className="space-y-4 relative z-10">
                                {exp.description.map((item, i) => (
                                    <li key={i} className="flex gap-4 text-white/70 leading-relaxed font-light">
                                        <span className="mt-2 w-1.5 h-1.5 bg-primary rounded-full shrink-0"></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Experience;
